import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import Select from '../dropdown/dropdown';
import SvgIcon from '@mui/material/SvgIcon';

function UpIcon(props) {
    return (
      <SvgIcon {...props}>
      <path fill="none" d="M0 0h24v24H0z"/><path d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z"/>
      </SvgIcon>
    );
  }

function DownIcon(props) {
return (
    <SvgIcon {...props}>
      <path fill="none" d="M0 0h24v24H0z"/><path d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z"/>
    </SvgIcon>
);
}

export default function ControlledAccordions(props) {
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div>
      <Accordion sx={{height: '30%'}} expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary
          expandIcon={expanded ? <DownIcon color="black" fontSize='large'/> : <UpIcon color="black" fontSize='large'/>}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography sx={{ }}>
            {props.title}
          </Typography>
        </AccordionSummary>
        <AccordionDetails sx={{alignItems: 'center', display : 'flex',justifyContent: 'center'}}>
           {props.children}
        </AccordionDetails>
      </Accordion>
    
    </div>
  );
}
